class AjaxSearch extends ajaxSearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.ajaxSearchResults = this.querySelector('[data-search-ajax]');
    this.allajaxSearchInstances = document.querySelectorAll('search-ajax');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchCond = '';
    this.ajaxEventListeners();
  }
  ajaxEventListeners() {
    this.input.form.addEventListener('submit', this.ajaxFormSubmit.bind(this));
    this.input.addEventListener('focus', this.inputFocus.bind(this));
    this.addEventListener('focusout', this.inputFocusOut.bind(this));
    this.addEventListener('keyup', this.inputKeyup.bind(this));
    this.addEventListener('keydown', this.inputKeydown.bind(this));
  }
  ajaxgetInquiry () {
    return this.input.value.trim();
  }
  triggerChange() {
    super.triggerChange();
    const searchCondNew = this.ajaxgetInquiry ();
    if (!this.searchCond || !searchCondNew.includes(this.searchCond)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector('#search-ajax-block')?.remove();
    }
    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateForCond(this.searchCond, searchCondNew);
    this.searchCond = searchCondNew;
    if (!this.searchCond.length) {
      this.close(true);
      return;
    }
    this.getAjaxResults(this.searchCond);
  }
  ajaxFormSubmit(event) {
    if (!this.ajaxgetInquiry ().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }
  ajaxFormReset(event) {
    super.ajaxFormReset(event);
    if (super.shouldResetForm()) {
      this.searchCond = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.clearInput(true);
    }
  }
  inputFocus() {
    const currentSearchTerm = this.ajaxgetInquiry ();
    if (!currentSearchTerm.length) return;
    if (this.searchCond !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.triggerChange();
    } else if (this.getAttribute('results') === 'true') {
      this.ajaxOpen();
    } else {
      this.getAjaxResults(this.searchCond);
    }
  }
  inputFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }
  inputKeyup(event) {
    if (!this.ajaxgetInquiry ().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.checkOption('up');
        break;
      case 'ArrowDown':
        this.checkOption('down');
        break;
      case 'Enter':
        this.menuOption();
        break;
    }
  }
  inputKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }
  updateForCond(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-search-ajax-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }
  checkOption(direction) {
    if (!this.getAttribute('open')) return;
    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.search-ajax__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;
    if (moveUp && !selectedElement) return;
    let selectedElementIndex = -1;
    let i = 0;
    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }
    this.statusElement.textContent = '';
    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }
    if (activeElementIndex === selectedElementIndex) return;
    const activeElement = allVisibleElements[activeElementIndex];
    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }
  menuOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
    if (selectedOption) selectedOption.click();
  }
  getAjaxResults(searchCond) {
    const queryKey = searchCond.replace(' ', '-').toLowerCase();
    this.ajaxLoader();
    if (this.cachedResults[queryKey]) {
      this.ajaxSendresult(this.cachedResults[queryKey]);
      return;
    }
    // Shopify search is often prefix-based per term. Using *wildcards* helps match
    // substrings like "goldfish" when searching "fish".
    const wildcardQuery = searchCond
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .map((term) => (term.length > 1 ? `*${term}*` : term))
      .join(' ');
    fetch(
      `${routes.ajax_search_url}?q=${encodeURIComponent(wildcardQuery)}&type=product&options%5Bprefix%5D=none&section_id=search-ajax`,
      {
      signal: this.abortController.signal,
      }
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-search-ajax').innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allajaxSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.ajaxSendresult(resultsMarkup);
        $('.item-data').on("click", function() {
          $(this).parents('.option-block').find(".variant-option").removeClass('active-variant');
          $(this).closest('form-wrap').addClass('active-variant');
          var it_img = $(this).attr('dataimg');
          $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('src',it_img);
      $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('srcset',it_img);
          var price = $(this).attr('dataprice');
          var compareprice = $(this).attr('datacompare');
          var stocks = $(this).attr('dataavailable');
          $(this).parents('.single-product-wrap').find('.price-box .new-price').text(Shopify.formatMoney(price, window.money_format));
          if (compareprice > price) {
            $(this).parents('.single-product-wrap').find('.price-box .old-price').show();
            $(this).parents('.single-product-wrap').find('.price-box .old-price').html(Shopify.formatMoney(compareprice, window.money_format));
          }else{
            $(this).parents('.single-product-wrap').find('.price-box .old-price').hide();
          }
        });
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }
  ajaxLoader() {
    this.statusElement = this.statusElement || this.querySelector('.search-ajax-status');
    this.setAttribute('loading', true);
  }
  ajaxInputText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }
  ajaxSendresult(resultsMarkup) {
    this.ajaxSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.sendInputresult();
    this.ajaxOpen();
    if (typeof initSearchAjaxProductButtons === 'function') {
      initSearchAjaxProductButtons();
    }
  }
  sendInputresult() {
    this.removeAttribute('loading');
    this.ajaxInputText(this.querySelector('[data-search-ajax-live-region-count-value]').textContent);
  }
  ajaxOpen() {
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }
  close(ajaxCondRemove = false) {
    this.clearInput(ajaxCondRemove);
    this.isOpen = false;
  }
  clearInput(ajaxCondRemove = false) {
    if (ajaxCondRemove) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');
    if (selected) selected.setAttribute('aria-selected', false);
    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
  }
}
customElements.define('search-ajax', AjaxSearch);

function initSearchAjaxProductButtons() {
  const $container = $('#search-ajax-results');
  if (!$container.length) return;

  // Quantity +/- controls
  $container.find('.qty-box').each(function () {
    const $box = $(this);
    if ($box.data('searchAjaxBound')) return;
    $box.data('searchAjaxBound', true);

    const $input = $box.find('.qty-box-input');
    if (!$input.length) return;

    const min = parseInt($input.attr('min') || '1', 10) || 1;

    $box.find('button[name="minus"]').on('click', function () {
      let value = parseInt($input.val() || '1', 10);
      if (isNaN(value)) value = 1;
      value = Math.max(min, value - 1);
      $input.val(value);

      // Keep hidden quantity input in sync, if present
      const $hiddenQty = $box
        .closest('cart-action, form')
        .find('input[id^="quantity-"], input[type="hidden"][name="quantity"]')
        .first();
      if ($hiddenQty.length) {
        $hiddenQty.val(value);
      }
    });

    $box.find('button[name="plus"]').on('click', function () {
      let value = parseInt($input.val() || '1', 10);
      if (isNaN(value)) value = 1;
      value += 1;
      $input.val(value);

      const $hiddenQty = $box
        .closest('cart-action, form')
        .find('input[id^="quantity-"], input[type="hidden"][name="quantity"]')
        .first();
      if ($hiddenQty.length) {
        $hiddenQty.val(value);
      }
    });
  });

  // Add to cart buttons
  $container.find('.ajax-cart-btn').each(function () {
    const $btn = $(this);
    if ($btn.data('searchAjaxBound')) return;
    $btn.data('searchAjaxBound', true);

    $btn.on('click', function (event) {
      event.preventDefault();
      if ($btn.is('[disabled]') || $btn.hasClass('loading')) return;

      const $wrap = $btn.closest('.single-product-wrap, .qty-action, form');
      if (!$wrap.length) return;

      const $variantInput = $wrap.find('.product-variant-id, input[name="id"]').first();
      if (!$variantInput.length) return;

      const productId = $variantInput.val();
      if (!productId) return;

      const $qtyHidden = $wrap.find('input[id^="quantity-"]');
      const quantity = parseInt($qtyHidden.val() || '1', 10) || 1;

      const url = window.Shopify.routes.root + 'cart/add.js';
      let sectionsToUpdate = 'ajax-cart';
      let sectionsToCount = 'ajax-cart-icon';

      $btn.addClass('loading');
      $btn.find('.ajax-loader').removeClass('hidden');

      let requestBody = {
        'items': [{
          'id': productId,
          'quantity': quantity
        }],
        'sections': sectionsToUpdate,
      };
      let requestBodyCount = {
        'items': [{
          'id': productId,
          'quantity': quantity
        }],
        'sections': sectionsToCount,
      };

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      }).then(response => {
        return response.json();
      }).then(data => {
        var parsed = $.parseHTML(data.sections['ajax-cart']);
        var result = $(parsed).find("#ajaxcart").html();
        $('#ajaxcart').html('');
        $('#ajaxcart').html(result);
        if($('.mini-cart').hasClass('is-empty')){
          document.querySelector('.mini-cart').classList.remove('is-empty');
        }
        setTimeout(function() {
          document.querySelector('.mini-cart').classList.add('animate', 'active');
        }, 200);
      }).catch((error) => {
        console.error('Error:', error);
      });

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBodyCount)
      }).then(response => {
        return response.json();
      }).then(data => {
        var parsedCount = $.parseHTML(data.sections['ajax-cart-icon']);
        var resultCount = $(parsedCount).find(".bigcounter").html();
        $('.bigcounter').html('');
        $('.bigcounter').html(resultCount);
      }).catch((error) => {
        console.error('Error:', error);
      }).finally(() => {
        $btn.removeClass('loading');
        $btn.find('.ajax-loader').addClass('hidden');
      });
    });
  });

  // Buy now buttons
  $container.find('.buy-now-btn').each(function () {
    const $btn = $(this);
    if ($btn.data('searchAjaxBound')) return;
    $btn.data('searchAjaxBound', true);

    $btn.on('click', function (event) {
      event.preventDefault();
      if ($btn.is('[disabled]') || $btn.hasClass('loading')) return;

      const $wrap = $btn.closest('.single-product-wrap, .qty-action, form');
      if (!$wrap.length) return;

      const $variantInput = $wrap.find('.product-variant-id, input[name="id"]').first();
      if (!$variantInput.length) return;

      const productId = $variantInput.val();
      if (!productId) return;

      const $qtyHidden = $wrap.find('input[id^="quantity-"]');
      const quantity = parseInt($qtyHidden.val() || '1', 10) || 1;

      const url = window.Shopify.routes.root + 'cart/add.js';

      $btn.addClass('loading');
      $btn.find('.ajax-loader').removeClass('hidden');

      let requestBody = {
        'items': [{
          'id': productId,
          'quantity': quantity
        }]
      };

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      }).then(response => response.json())
      .then(() => {
        window.location.href = window.Shopify.routes.root + 'checkout';
      }).catch((error) => {
        console.error('Error:', error);
      }).finally(() => {
        $btn.removeClass('loading');
        $btn.find('.ajax-loader').addClass('hidden');
      });
    });
  });
}